export { default as Carousel } from './Carousel';
